import { createAction } from 'redux-actions'

import {
  SET_ORDERS,
  SET_SELECTED_ORDER_IDS,
  SET_TARGET_ORDER_ID,
} from './constants'

export const setSelectedOrderIds = createAction(SET_SELECTED_ORDER_IDS)
export const setOrders = createAction(SET_ORDERS)
export const setTargetOrderId = createAction(SET_TARGET_ORDER_ID)
